import { Button } from '@mui/material';
import type { ReportJobStatuses, ReportJobTypes } from '@weft/types';
import { REPORT_JOB_TYPES } from '@weft/types';
import { REPORT_JOB_STATUSES } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';
import { OpenNewTabIcon } from 'apps/app/src/components/icons/OpenNewTabIcon';
import { Link } from 'react-router-dom';

type OpenReportButtonProps = {
  reportId: string;
  status: ReportJobStatuses;
  type: ReportJobTypes;
};

export const OpenReportButton: React.FC<OpenReportButtonProps> = ({ reportId, status, type }) => {
  const isJobCompleted = status === REPORT_JOB_STATUSES.Completed;
  
  return (
    isJobCompleted ? (
      <Button
        component={Link}
        variant='outlined'
        size='small'
        color='primary'
        to={`/reports/${getNavigationPath(type)}/${reportId}`}
        endIcon={
          <OpenNewTabIcon
            width={17}
            height={17}
          />}
      >
        Open
      </Button>
    ) : null
  );
};

function getNavigationPath(reportType: ReportJobTypes): string {
  switch (reportType) {
    case REPORT_JOB_TYPES.CommitmentUsage:
      return 'commitment-usage';
    case REPORT_JOB_TYPES.UnchargedUsage:
      return 'uncharged-usage';
    case REPORT_JOB_TYPES.ProductsUsage:
      return 'product';
    case REPORT_JOB_TYPES.CustomerRevenue:
      return 'customer-revenue';
    case REPORT_JOB_TYPES.Contracts:
      return 'contracts';
    case REPORT_JOB_TYPES.AnonymousCustomers:
      return 'anonymous-customers';
    case REPORT_JOB_TYPES.MonthlyClosure:
      return 'monthly-closure';
    default:
      return raiseUnreachable(reportType);
  }
}